import type { BiographyClock } from '../types/biography.types';
export function biographyRemaining(deadline: string, clock: BiographyClock | null, monotonic: number): number | null {
  const end = Date.parse(deadline);
  if (!clock || !Number.isFinite(end)) return null;
  return Math.max(0, Math.ceil((end - clock.utc - Math.max(0, monotonic - clock.monotonic)) / 1000));
}
